import React, { useEffect, useState } from 'react'
import crmservices from '../../wsclient'
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { cache } from '../../utils/cache';
import { Box, Button, CircularProgress, Grid, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DeliveryIcon, EditBoxIcon, EditIcon, iconFontSize, ShopIcon } from '../../components/IconComponent';
import Modal from '../../components/Modal';
import DeliveryAddressesController from './DeliveryAddressesController';
import AddAddressController from "../my-addresses/AddAddressController";
import AddressMapController from "../my-addresses/AddressMapController";
import PickupStoreController from './PickupStoreController';
import { getContactAddress, getStoreAddress } from '../../utils/util';
import LoadingComponent from '../../components/Loading';
import AlertComponent from '../../components/Alert';
import { custom_page } from '../../custom.config';
import CurrentLocationController from './CurrentLocationController';
import BoxContent from '../../components/BoxContent';
import SwitchSelector from "react-switch-selector";
import { GetIconColor } from '../../theme/main_style';

const AddAddressPage = custom_page.my_address && custom_page.my_address.add_address && custom_page.my_address.add_address.controller ? require('../../custom_src/pages/my-addressres/AddAddressController').default : AddAddressController;
const AddressMapPage = custom_page.my_address && custom_page.my_address.address_map && custom_page.my_address.address_map.controller ? require('../../custom_src/pages/my-addressres/AddressMapController').default : AddressMapController;

export default function OrderSupplyMethod(props) {
    const { t } = useTranslation();
    const { palette } = useTheme();
    const orders = cache.getOrders();
    const { order_type, delivery_address, pick_up_store } = orders;

    const [loadingSupplyMethod, setLoadingSupplyMethod] = useState(false);
    const [showProcessing, setShowProcessing] = useState(false);
    const [message, setMessage] = useState();
    const [showAddresses, setShowAddresses] = useState(false);
    const [showPickupStore, setShowPickupStore] = useState(false);
    const [showDeliveryFulfilmentStore, setShowDeliveryFulfilmentStore] = useState(false);
    const [locationDetail, setLocationDetail] = useState(null);
    const [pickupStores, setPickupStores] = useState([]);
    const [loadingStore, setLoadingStore] = useState(false);
    const [loadDataCompleted, setLoadDataCompleted] = useState(false);
    const [initiateOrder, setInitiateOrder] = useState();
    const [customerAddress, setCustomerAddress] = useState(delivery_address);
    const [showAddressMap, setShowAddressMap] = useState(false);
    const [showAddAddress, setShowAddAddress] = useState(false);
    const [addressMode, setAddressMode] = useState(null);
    const [currentLocation, setCurrentLocation] = useState(props.currentLocation ? props.currentLocation : null);
    const [showCurrentLocation, setShowCurrentLocation] = useState(false);
    const [fulfillmentStores, setFulfillmentStores] = useState([]);

    const appConfig = cache.getAppConfig();
    let supportDelivery = appConfig.features.contact.order && appConfig.features.contact.order.delivery && appConfig.features.contact.order.delivery.is_supported;
    let supportPickUp = appConfig.features.contact.order && appConfig.features.contact.order.pick_up && appConfig.features.contact.order.pick_up.is_supported;
    let supportDirectSale = appConfig.features.contact.order && appConfig.features.contact.order.direct_sale && appConfig.features.contact.order.direct_sale.is_supported;
    let isOnlySupportDirectSale = supportDirectSale && !supportDelivery && !supportPickUp
    let allowDeliverySelection = appConfig.features.contact.order && appConfig.features.contact.order.fulfilment_flows && appConfig.features.contact.order.fulfilment_flows.allow_delivery_selection;

   
    let supplyMethodOptions = [];
    if (supportDelivery) {
        supplyMethodOptions.push({
            label: "Delivery",
            value: "DELIVERY",
            selectedBackgroundColor: palette.primary.main
        });
    }
    if (supportPickUp) {
        supplyMethodOptions.push({
                label: "Pick Up",
                value: "PICK_UP",
                selectedBackgroundColor: palette.primary.main,
        });
    }

    useEffect(() => {
        getLocation();
        onInitOrderMethod();
        //removed since getlocation will either call it after change of location or error
        //onLoadCustomerAddress();
    }, [])

    useEffect(() => {
        if (props.isFulfillmentValid && props.isFulfillmentValid === 'invalid') {
            setInitiateOrder(props.initiateOrder)
        }
    }, [props.isFulfillmentValid]);

    useEffect(() => {
        if (currentLocation && currentLocation.lat && currentLocation.lon && !loadDataCompleted) {
            onLoadData()
        }
    }, [currentLocation])

    const getLocation = () => {
        let isAllowOrder = cache.getAllowOrderContact();
        if((window.natively.isIOSApp || window.natively.isAndroidApp) && isAllowOrder)
		{
			const locationService = new NativelyLocation(); // eslint-disable-line
			const location_callback = function (resp) {
				let currentLocation = {
					lat: resp.latitude,
					lon: resp.longitude,
				}
				setCurrentLocation(currentLocation);
				setShowProcessing(false);
			};
			const minAccuracy = 50;
			const accuracyType = "Best";
			const priority_android = "BALANCED";
			locationService.current(minAccuracy, accuracyType, priority_android, location_callback);
		}
        else
        {
            navigator.geolocation.getCurrentPosition((location) => {
                var _currentLocation = {
                    lat: location.coords.latitude,
                    lon: location.coords.longitude,
                }
                if(!(currentLocation && currentLocation.lat && currentLocation.lon
                    && _currentLocation && _currentLocation.lat && _currentLocation.lon
                    && currentLocation.lat === _currentLocation.lat && currentLocation.lon === _currentLocation.lon))
                {
                    setCurrentLocation(_currentLocation);

                }
                setShowProcessing(false);
            }, (err) => {
                console.log('getLocation err', err)
                setShowProcessing(false);
                onLoadData();
            }, {
                timeout: 60000,
                enableHighAccuracy: false
            });
        }
    }
    const onInitOrderMethod = async () => {
        const orders = cache.getOrders();
        let initiateOrder = null;
        if(orders.order_type === 'DIRECT_SALE' && (supportDelivery ||supportPickUp))
        {
            let initOrder = await dataUtil.onInitOrder({ location: currentLocation, appConfig: appConfig, skipLastOrder: true });
            await props.reloadFunc({ supply_method: initOrder.supply_method, fulfilled_by:  initOrder.fulfilled_by, customer_address: initOrder.customer_address });
            const orders = cache.getOrders();
            let isDelivery = orders.order_type && orders.order_type === 'DELIVERY'
            initiateOrder = {
                supply_method: orders.order_type,
                fulfilled_by: isDelivery  ? orders.delivery_fulfilled_by : orders.pick_up_store,
                customer_address: orders.delivery_address
            }
        }
        else{
            let isDelivery = orders.order_type && orders.order_type === 'DELIVERY'
            initiateOrder = {
                supply_method: orders.order_type,
                fulfilled_by: isDelivery  ? orders.delivery_fulfilled_by : orders.pick_up_store,
                customer_address: orders.delivery_address
            }
        }
        setInitiateOrder(initiateOrder)
    }

    const onLoadData = async () => {
        if (order_type === 'DELIVERY') {
            await onLoadCustomerAddress();
            await onLoadFulfillmentStore();
        }
        else{
            await onLoadPickupStore();
        }
        setLoadDataCompleted(true);
        // if(props.setShowProcessingSupply){
        //     props.setShowProcessingSupply(false);
        // }
    }

    const onLoadCustomerAddress = async () => {
        let resullt = await dataUtil.getCustomerAddressForOrder({ location: currentLocation });
        const customerAddress = resullt.customer_address;
        setCustomerAddress(customerAddress)
    }

    const onLoadPickupStore = async () => {
        setLoadingStore(true);
        var stores = [];
        try {
            var body = {
                supply_method: 'PICK_UP'
            }
            if (currentLocation && currentLocation.lat && currentLocation.lon)
                body.lat_lot = currentLocation.lat + ":" + currentLocation.lon;
                var result = await crmservices.orders.estimateOrderFulfillment(body);
            if (result.code === 'OK') {
                stores = result.data && result.data.fulfilled_by ? result.data.fulfilled_by : [];
            }
        } catch (error) {
            console.log("load merchants exception:", error);
        }
        setPickupStores(stores);
        setLoadingStore(false);
        return stores;
    }

    const onLoadFulfillmentStore = async () => {
        setLoadingStore(true);
        var stores = [];
        try {
            var body = {
                supply_method: 'DELIVERY'
            }
            if (currentLocation && currentLocation.lat && currentLocation.lon)
                body.lat_lot = currentLocation.lat + ":" + currentLocation.lon;
                var result = await crmservices.orders.estimateOrderFulfillment(body);
            if (result.code === 'OK') {
                stores = result.data && result.data.fulfilled_by ? result.data.fulfilled_by : [];
            }
        } catch (error) {
            console.log("load merchants exception:", error);
        }
        setFulfillmentStores(stores);
        setLoadingStore(false);
        return stores;
    }


    const onLoadCurrentLocation = async () => {
        let location_detail = null;
        if(!cache.getCurrentLocation())
        {
            if (currentLocation && currentLocation.lat && currentLocation.lon) {
                try {
                    var result = await crmservices.config.getAddress({ latlng: currentLocation.lat + ',' + currentLocation.lon });
                    if (result.code === 'OK') {
                        if (result.data) {
                            location_detail = result.data;
                            cache.setCurrentLocation(location_detail);
                        }
                    }
                } catch (error) {
                    console.log("onLoadCurrentLocation find address exception:", error);
                }
            }
        }
        location_detail = cache.getCurrentLocation();
        setLocationDetail(location_detail);
    }

    const onSelectAddress = async (deliveryAddress) => {
        setShowAddresses(false);
        let customerAddress = deliveryAddress.type === 'address' ? deliveryAddress.address : locationDetail;
        await props.reloadFunc({ supply_method: "DELIVERY", customer_address: customerAddress });
        onInitOrderMethod();
    }

    const onGoBackFromCurrrentLocation = async (currentAddress) => {
        setLocationDetail(currentAddress)
        await props.reloadFunc({ supply_method: "DELIVERY", customer_address: currentAddress });
    }

    const onAddNewAddress = () => {
        setShowAddAddress(true);
        setShowAddresses(false);
        setAddressMode('add');
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    const onChangePickupStore = async (store) => {
        setShowPickupStore(false);
        await props.reloadFunc({ supply_method: "PICK_UP", fulfilled_by: store });
        onInitOrderMethod();
    }

    const onChangeDeliveryFulfilmentStore = async (store) => {
        setShowDeliveryFulfilmentStore(false);
        await props.reloadFunc({ supply_method: "DELIVERY", fulfilled_by: store , customer_address: customerAddress});
        onInitOrderMethod();
    }

    const onEdit = (e, type) => {
        if (type === 'delivery') {
            setShowAddresses(true);
            onLoadCurrentLocation();
        } 
        else if (type === 'delivery_fulfilment') {
            setShowDeliveryFulfilmentStore(true);
        } else {
            setShowPickupStore(true);
        }
    }

    const onChangeOrderMethod = async (method) => {
        setShowProcessing(true);
        let store = null;
        if (method === 'PICK_UP' || method === 'DIRECT_SALE') {
            store = pickupStores[0]
            if (!store) {
                let storesForPickUp = await onLoadPickupStore();
                store = storesForPickUp[0];
            }
        } else {
            if (!customerAddress) {
                let storesForDelivery = await onLoadFulfillmentStore();
                store = storesForDelivery[0];
            }
        }
        setShowProcessing(false);
        await props.reloadFunc({ supply_method: method, fulfilled_by: store, customer_address: customerAddress });
        onInitOrderMethod();
    }

    const onCloseSelectAddressMap = (address_info) => {
        setShowAddressMap(false);
        if (addressMode === 'add') {
            setCurrentLocation(prevState => ({
                ...prevState,
                location_detail: address_info,
            }))
            setShowAddAddress(true);
        } else {
            setCurrentLocation(prevState => ({
                ...prevState,
                location_detail: address_info,
            }))
            setShowCurrentLocation(true);
        }
    }

    const onChange = (newValue) => {
        onChangeOrderMethod(newValue)
    };

    const initialSelectedIndex = supplyMethodOptions.findIndex(({value}) => value === (initiateOrder && initiateOrder.supply_method ? initiateOrder.supply_method : "DELIVERY"));

    let storeSelected = pick_up_store;
    if (!storeSelected || !storeSelected.id) {
        storeSelected = !loadingStore && pickupStores.length > 0 ? pickupStores[0] : null;
    }

    return (
        <>
            {!loadDataCompleted ? <center><CircularProgress /></center> :
            <>
            <Box py={0}>
                {initiateOrder&&!initiateOrder.fulfilled_by && initiateOrder.supply_method === 'PICK_UP' &&
                    <Typography color={palette.error.main} variant='subtitle2'>{t('CAN_NOT_FULFILL_ORDER_EXCEPTION_PICK_UP')}</Typography>
                }
                {initiateOrder&&!initiateOrder.fulfilled_by && initiateOrder.supply_method === 'DELIVERY' &&
                    <Typography color={palette.error.main} variant='subtitle2'>{t('CAN_NOT_FULFILL_ORDER_EXCEPTION_DELIVERY')}</Typography>
                }
                {initiateOrder && <BoxContent noPaddingX noBorderBottom={props.from!=="shopping_cart"}
                >
                <Stack direction={'row'} spacing={1} alignItems='center'>
                    <Stack flex={1} spacing={1}>
                        {!isOnlySupportDirectSale &&
                            <Grid sx={{width: window.innerWidth < 600 ? '100%' : 16*supplyMethodOptions.length/100, height: 40}} item>
                                <SwitchSelector
                                    onChange={onChange}
                                    options={supplyMethodOptions}
                                    initialSelectedIndex={initialSelectedIndex}
                                    backgroundColor={palette.primary.light}
                                    fontColor={"#f5f6fa"}
                                />
                            </Grid>
                        }
                        {initiateOrder.supply_method === 'DELIVERY' && <Stack spacing={2} width={'100%'}>
                            <Box width={'100%'}>
                                <Stack direction="row" spacing={2} alignItems="flex-start" marginTop={2}
                                        sx={{cursor: "pointer"}}
                                        onClick={(e) => onEdit(e, "delivery")}>
                                    <DeliveryIcon color={GetIconColor().unselected}/>
                                    <Stack spacing={0}>
                                        {initiateOrder.customer_address && <Typography>{getContactAddress(initiateOrder.customer_address)}</Typography>}
                                        {/* <Button 
                                            sx={{ alignSelf: "flex-start", padding: 0, minHeight: "auto" }} 
                                            onClick={(e) => onEdit(e, "delivery")} 
                                            size="small" 
                                            variant="text"
                                        >
                                            {initiateOrder.customer_address ? t("change_delivery_address") :  t("add_delivery_address")}
                                        </Button> */}
                                    </Stack>
                                    <Stack direction="row" spacing={1} alignItems="flex-end">
                                        <EditIcon  size={iconFontSize.xxs} color={palette.primary.main} />
                                    </Stack>
                                </Stack>

                                {allowDeliverySelection && fulfillmentStores && fulfillmentStores.length > 1 &&
                                    <Stack direction="row" spacing={2} alignItems="flex-start" marginTop={2} 
                                            sx={{cursor: "pointer"}}
                                            onClick={(e) => onEdit(e, "delivery_fulfilment")} >
                                        <ShopIcon color={GetIconColor().unselected}/>
                                        <Stack spacing={0}>
                                            {initiateOrder.fulfilled_by && <Typography>{initiateOrder.fulfilled_by.name}</Typography>}
                                            {/* {initiateOrder.fulfilled_by && initiateOrder.fulfilled_by.address && <Typography variant='subtitle2'>{getStoreAddress(initiateOrder.fulfilled_by)}</Typography>}
                                            <Button 
                                                sx={{ alignSelf: "flex-start", padding: 0, minHeight: "auto" }} 
                                                onClick={(e) => onEdit(e, "delivery_fulfilment")} 
                                                size="small" 
                                                variant="text"
                                            >
                                                {t("change_filfillment_store")}
                                            </Button> */}
                                        </Stack>
                                        <Stack direction="row" spacing={1} alignItems="flex-end">
                                            <EditIcon size={iconFontSize.xxs} color={palette.primary.main}/>
                                        </Stack>                                    
                                    </Stack>}
                            </Box> 
                        </Stack>}
                        {initiateOrder.supply_method === 'PICK_UP' && <Stack spacing={2} width={'100%'}>
                            {initiateOrder.fulfilled_by && initiateOrder.fulfilled_by.name ?
                                <Box width={'100%'}>
                                    <Stack direction="row" spacing={2} alignItems="flex-start" marginTop={2} 
                                            sx={{cursor: "pointer"}}
                                            onClick={(e) => onEdit(e, "pick_up")} >
                                        <ShopIcon color={GetIconColor().unselected}/>
                                        <Stack spacing={0}>
                                            <Typography>{initiateOrder.fulfilled_by.name}</Typography>
                                            {/*{initiateOrder.fulfilled_by.address && <Typography variant='subtitle2'>{getStoreAddress(initiateOrder.fulfilled_by)}</Typography>}
                                             <Button 
                                                sx={{ alignSelf: "flex-start", padding: 0, minHeight: "auto" }} 
                                                onClick={(e) => onEdit(e, "pick_up")} 
                                                size="small" 
                                                variant="text"
                                            >
                                                {t("change_pickup_location")}
                                            </Button> */}
                                        </Stack>
                                        <Stack direction="row" spacing={1} alignItems="flex-end">
                                            <EditIcon size={iconFontSize.xxs} color={palette.primary.main}/>
                                        </Stack> 
                                    </Stack>
                                </Box> :
                                <Box width={'100%'}>
                                    <Typography color={palette.error.main} variant='subtitle2'>{t('CAN_NOT_FULFILL_ORDER_EXCEPTION_PICK_UP')}</Typography>
                                    <Button sx={{justifyContent:'flex-start', marginTop:'1'}} onClick={(e) => onEdit(e, 'pick_up')} size='small' variant={'text'}>{t('change pick up store')}</Button>
                                </Box>}
                        </Stack>}
                    </Stack>
                </Stack>
                </BoxContent>}
                {showAddresses && <Modal enableCloseButton maxWidth={"md"} isOpen={showAddresses} title={t('select_your_delivery_address')} onClose={() => setShowAddresses(false)}>
                    <DeliveryAddressesController
                        isOpen={showAddresses}
                        currentLocation={{ ...currentLocation, location_detail: locationDetail }}
                        onClose={() => setShowAddresses(false)}
                        onSelectAddress={onSelectAddress}
                        onAddNewAddress={onAddNewAddress}
                    />
                </Modal>}
                {showCurrentLocation && <Modal enableCloseButton maxWidth={"md"} isOpen={showCurrentLocation} title={t('my_address')} onClose={() => setShowCurrentLocation(false)}>
                    <CurrentLocationController currentLocation={currentLocation} onGoBack={onGoBackFromCurrrentLocation} onSelectAddressMap={onCloseSelectAddressMap} />
                </Modal>}
                {showPickupStore && <PickupStoreController
                    onClose={() => setShowPickupStore(false)}
                    title={t('select_your_pickup_location')}
                    isOpen={showPickupStore}
                    currentLocation={currentLocation}
                    initiateOrder={initiateOrder}
                    showMessage={showMessage}
                    onGoBackPickUpStore={onChangePickupStore}
                />}
                {showDeliveryFulfilmentStore && <PickupStoreController
                    onClose={() => setShowDeliveryFulfilmentStore(false)}
                    title={t('select_your_fulfillment_store')}
                    isOpen={showDeliveryFulfilmentStore}
                    currentLocation={currentLocation}
                    initiateOrder={initiateOrder}
                    showMessage={showMessage}
                    onGoBackPickUpStore={onChangeDeliveryFulfilmentStore}
                />}
                {showAddressMap && <AddressMapPage
                    open={showAddressMap}
                    onClose={() => setShowAddressMap(false)}
                    onGoBackFn={onCloseSelectAddressMap}
                />}
                {showAddAddress && <AddAddressPage
                    open={showAddAddress}
                    address_info={currentLocation && currentLocation.location_detail ? currentLocation.location_detail : null}
                    mode={'add'}
                    onClose={() => setShowAddAddress(false)}
                    onRefresh={() => setShowAddresses(true)}
                />}
                {showProcessing && <LoadingComponent showLoading={showProcessing === undefined ? false : showProcessing} />}
                {message && message.show && <AlertComponent
                    isOpen={message.show}
                    message={message.content}
                    otherMessage={message.otherMessage ? message.otherMessage : null}
                    onClose={message.callBackFn}
                />}
            </Box>
            </>
        }
        </>
        
    )
}